
(function(){
  var path=window.location.pathname;
  var map={
    "/pages/a-propos":"lfe-page-a-propos",
    "/pages/comment-vendre-un-sac":"lfe-page-vendre",
    "/pages/nos-boutiques":"lfe-page-boutiques",
    "/pages/abonnement-fidelite":"lfe-page-club"
  };
  if(map[path]) document.body.classList.add(map[path]);

  var mainCollections={
    "/collections/sac":"lfe-main-collection--sac",
    "/collections/souliers":"lfe-main-collection--souliers",
    "/collections/vetements":"lfe-main-collection--vetements",
    "/collections/accessoires":"lfe-main-collection--accessoires",
    "/collections/bijoux":"lfe-main-collection--bijoux",
    "/collections/nouveautes":"lfe-main-collection--selection",
    "/collections/la-bagagerie":"lfe-main-collection--bagagerie",
    "/collections/1000":"lfe-main-collection--selection",
    "/collections/hermes-birkin-d-occasion":"lfe-main-collection--selection",
    "/collections/hermes-kelly-d-occasion":"lfe-main-collection--selection",
    "/collections/chanel-timeless-d-occasion":"lfe-main-collection--selection",
    "/collections/sacs-chanel-boy-d-occasion":"lfe-main-collection--selection",
    "/collections/sacs-dior-saddle-d-occasion":"lfe-main-collection--selection",
    "/collections/sacs-lady-dior-d-occasion":"lfe-main-collection--selection",
    "/collections/sacs-louis-vuitton-speedy-d-occasion":"lfe-main-collection--selection",
    "/collections/sacs-louis-vuitton-neverfull-d-occasion":"lfe-main-collection--selection"
  };
  if(path.indexOf("/collections/")===0){
    document.body.classList.add("lfe-main-collection");
  }
  if(mainCollections[path]){
    document.body.classList.add(mainCollections[path]);
  }

  document.querySelectorAll('header a[href="/collections"], header a[href$="/collections"], .menu-drawer a[href="/collections"], .menu-drawer a[href$="/collections"]').forEach(function(link){
    var label=(link.textContent||"").replace(/\s+/g," ").trim().toLowerCase();
    if(label==="marques") link.setAttribute("href","/collections#marques");
    if(label==="sélections"||label==="selections") link.setAttribute("href","/collections#selections");
  });

  var desktopList=document.querySelector("nav.header__inline-menu > ul.list-menu--inline");
  if(desktopList){
    var maisonRoot=desktopList.querySelector('a[href="/pages/a-propos"]');
    var maisonSubmenu=maisonRoot && maisonRoot.closest("li") ? maisonRoot.closest("li").querySelector(".list-menu-dropdown > ul.list-menu") : null;
    if(maisonSubmenu && !maisonSubmenu.querySelector(":scope > .lfe-maison-menu-link")){
      var maisonRow=document.createElement("li");
      maisonRow.className="lfe-maison-menu-link";
      var maisonWrap=document.createElement("dropdown-menu");
      var maisonLink=document.createElement("a");
      maisonLink.href="/pages/a-propos";
      maisonLink.className="header__menu-item list-menu__item focus-inset";
      if(path==="/pages/a-propos") maisonLink.classList.add("header__active-menu-item");
      maisonLink.innerHTML='<span class="label">La Maison</span>';
      maisonWrap.appendChild(maisonLink);
      maisonRow.appendChild(maisonWrap);
      maisonSubmenu.prepend(maisonRow);
    }

    desktopList.querySelectorAll('a[href="/pages/comment-vendre-un-sac"]').forEach(function(anchor){
      var item=anchor.closest("li");
      if(item && item.parentElement!==desktopList) item.remove();
    });
    if(!desktopList.querySelector(".lfe-sell-menu")){
      var row=document.createElement("li");
      row.className="lfe-sell-menu";
      var link=document.createElement("a");
      link.href="/pages/comment-vendre-un-sac";
      link.className="header__menu-item header__menu-item--top list-menu__item focus-inset";
      link.innerHTML="<span>Vendre un article</span>";
      if(path==="/pages/comment-vendre-un-sac") link.setAttribute("aria-current","page");
      row.appendChild(link);
      desktopList.appendChild(row);
    }
  }

  var mobileMaisonList=document.querySelector("#menu-drawer #link-la-maison ul.menu-drawer__menu");
  if(mobileMaisonList && !mobileMaisonList.querySelector(":scope > .lfe-maison-menu-link")){
    var mobileMaisonRow=document.createElement("li");
    mobileMaisonRow.className="lfe-maison-menu-link";
    var mobileMaisonLink=document.createElement("a");
    mobileMaisonLink.href="/pages/a-propos";
    mobileMaisonLink.className="menu-drawer__menu-item list-menu__item focus-inset";
    if(path==="/pages/a-propos") mobileMaisonLink.classList.add("menu-drawer__menu-item--active");
    mobileMaisonLink.textContent="La Maison";
    mobileMaisonRow.appendChild(mobileMaisonLink);
    mobileMaisonList.prepend(mobileMaisonRow);
  }

  document.querySelectorAll(".lfe-product-reassurance").forEach(function(grid){
    Array.from(grid.children).forEach(function(item){
      if(item.classList.contains("lfe-trust-item")) return;
      item.classList.add("lfe-trust-item");
      Array.from(item.childNodes).forEach(function(node){
        if(node.nodeType===3) node.textContent=node.textContent.replace(/^\s*✓\s*/,"");
      });
      var icon=document.createElement("span");
      icon.className="lfe-trust-icon";
      icon.setAttribute("aria-hidden","true");
      icon.textContent="✓";
      item.prepend(icon);
    });
  });
  if(path==="/collections/sac"){
    document.body.classList.add("lfe-collection-sac");
    var collectionTitle=document.querySelector(".collection-hero__title");
    if(collectionTitle) collectionTitle.innerHTML='<span class="visually-hidden">Collection :</span>Sacs de luxe';
    var collectionPreview=document.querySelector(".collection-hero__description-preview");
    if(collectionPreview) collectionPreview.innerHTML="<p>Découvrez une sélection de sacs Chanel, Hermès, Louis Vuitton et d’autres grandes maisons, proposés dans différents états — neufs, jamais portés ou de seconde main — et authentifiés par nos experts.</p>";
    document.querySelectorAll(".collection-hero__description-rest,.collection-hero__description-toggle").forEach(function(element){element.remove();});
  }

  if(document.body.classList.contains("template-article")){
    var articleHeader=document.querySelector(".article-template header");
    var articleContent=document.querySelector(".article-template__content");
    if(articleHeader && articleContent && !articleHeader.querySelector(".lfe-article-standfirst")){
      var standfirst=Array.from(articleContent.children).find(function(element){
        return element.tagName==="P" && element.textContent.trim().length>40;
      });
      if(standfirst){
        standfirst.classList.add("lfe-article-standfirst");
        articleHeader.appendChild(standfirst);
      }
    }
  }

  if(path==="/products/hermes-sac-birkin-25-togo-commende-speciale"){
    document.querySelectorAll(".product__accordion .accordion__content p").forEach(function(paragraph){
      if(paragraph.textContent.indexOf("Hermès – Sac Birkin 25 Gold Togo")!==-1){
        paragraph.innerHTML=paragraph.innerHTML.replace("Hermès – Sac Birkin 25 Gold Togo","Hermès – Sac Birkin 25 Togo, commande spéciale HSS");
      }
    });
  }


})();
